import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.935 5.002c1.438-1.448 3.475-1.718 5.11-.883l-.266.523.267-.523c.965.492 1.665 1.253 1.999 2.213.258.741.284 1.56.09 2.407 1.712.597 2.733 2.034 2.808 3.483.055 1.071-.229 2.044-.855 2.789-.627.745-1.544 1.2-2.635 1.334a.7.7 0 0 1-.171-1.39c.803-.099 1.373-.415 1.734-.845.362-.43.57-1.037.53-1.816-.05-.953-.842-2.087-2.414-2.375a.7.7 0 0 1-.53-.932c.32-.865.325-1.607.12-2.195-.202-.582-.633-1.08-1.312-1.426-1.215-.62-2.813-.356-3.846 1.05A.7.7 0 0 1 9.5 6.49c-.544-.555-1.106-.875-1.645-.989-.525-.112-1.076-.04-1.644.27-.587.365-.882.767-1.046 1.192-.176.453-.221.978-.222 1.623a.7.7 0 0 1-.635.696c-1.01.094-1.71.478-2.16.986-.454.513-.698 1.204-.698 1.988 0 1.257.846 2.364 2.113 2.719a.7.7 0 0 1-.377 1.348C1.336 15.806.05 14.164.05 12.257c0-1.076.338-2.112 1.05-2.916.599-.677 1.43-1.153 2.46-1.361.028-.503.106-1.021.299-1.521.282-.729.79-1.37 1.632-1.888a.71.71 0 0 1 .029-.017c.85-.47 1.748-.608 2.626-.421.64.135 1.24.438 1.789.87Zm3.316 4.406a.7.7 0 0 1 .22.965l-3.161 5.022a.7.7 0 0 1-1.089.12l-2.595-2.609a.7.7 0 0 1 .993-.987l1.974 1.986 2.692-4.278a.7.7 0 0 1 .966-.22Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
